export default __webpack_public_path__ + "static/media/hh-banner-house.863e855c.jpg";